<template>
  <div class="userSegment">
    <el-popover
      placement="bottom-end"
      width="450"
      trigger="click"
      popper-class="notify-popover"
      v-model="showNotify"
      v-if="!isAdmin"
    >
      <div class="notify">
        <div
          class="
            header
            font-weight__bold
            font-size__small
            flex-row flex__between
          "
        >
          Thông báo
        </div>
        <VuePerfectScrollbar
          class="scroll-area"
          :settings="perfectScrollbarSetting"
          infinite-wrapper
        >
          <div class="body">
            <div
              :class="[
                'ele-notify flex-row clickable',
                item.status === 'unSeen' ? 'read' : '',
              ]"
              v-for="item in listNotify"
              :key="item.id"
            >
              <notify-content
                @hideNotify="showNotify = false"
                :item="item"
              ></notify-content>
            </div>
            <infinite-loading
              ref="infiniteLoading"
              spinner="spiral"
              @infinite="infiniteHandler"
            >
              <div slot="no-more"></div>
              <div slot="no-results">Không có dữ liệu</div>
            </infinite-loading>
          </div>
        </VuePerfectScrollbar>
      </div>
      <div
        slot="reference"
        class="btnIcon notifyToggler clickable margin-right-10"
        @click="refeshNoti"
      >
        <el-badge :is-dot="!!countUnSeen()">
          <i class="fas fa-bell"></i>
        </el-badge>
      </div>
    </el-popover>

    <el-popover
      placement="bottom-start"
      trigger="click"
      popper-class="user-popover"
    >
      <div class="menu-user">
        <div class="profile">
          <div class="metaInfo">
            <div class="item">
              <i class="fas fa-user color__link margin-right-10"></i>
              <span>&nbsp;{{ user ? user.fullName : "---" }}</span>
            </div>

            <div class="item">
              <i class="fas fa-mobile color__link margin-right-10"></i>
              <span>&nbsp;{{ user ? user.mobile : "---" }}</span>
            </div>

            <div class="item">
              <i class="fas fa-envelope color__link margin-right-10"></i>
              <span>{{ user ? user.email : "---" }}</span>
            </div>

            <div
              class="item clickable"
              @click="$router.push({ name: 'profileManagement' })"
            >
              <i class="fas fa-cog color__link margin-right-10"></i>
              <span>Cài đặt</span>
            </div>

            <div class="item clickable" @click="logout">
              <i class="fas fa-sign-out-alt color__link margin-right-10"></i>
              <span>Đăng xuất</span>
            </div>
          </div>
        </div>

        <!-- <el-button
          size="mini"
          class="btnSolid__blue"
          @click="$router.push({ name: 'profileManagement' })"
        >
          &nbsp;Quản lý profile
        </el-button>

        <el-button size="mini" class="btnSolid__blue">
          <i class="fas fa-sign-out-alt"></i>
          &nbsp;Đăng xuất
        </el-button> -->
      </div>

      <div slot="reference" class="profile clickable">
        <div
          class="thumbnail flex-row flex__center"
          :style="setBackground"
        ></div>
        <div class="txt">
          <span class="name no_wrap"
            >Ông/Bà {{ user ? user.fullName : "" }}</span
          >
          <span class="role">{{ user ? user.mobile : "" }}</span>
        </div>
      </div>

      <!-- <i slot="reference" class="fas fa-caret-down clickable"></i> -->
    </el-popover>
  </div>
</template>

<script>
import vbNotificationService from "../../services/vbNotificationService";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NotifyContent from "./notify-content";
import InfiniteLoading from "vue-infinite-loading";
import constants from "../../constants.js";

export default {
  name: "user-header",

  components: {
    NotifyContent,
    VuePerfectScrollbar,
    InfiniteLoading,
  },
  computed: {
    isAdmin() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.roleCode === constants.ROLE.CODE.ADMIN
      );
    },
    user() {
      return this.$store.getters.user;
    },
    listNotify() {
      return this.$store.getters.notifies;
    },
    notificationsUnreadCount() {
      return "";
    },
    setBackground() {
      if (this.$store.getters.user && this.$store.getters.user.iconPhoto) {
        return {
          "background-image": "url(" + this.$store.getters.user.iconPhoto + ")",
        };
      }
    },
  },
  methods: {
    refeshNoti() {
      this.$store.commit("refreshNoti");
    },

    infiniteHandler($state) {
      this.list().then((items) => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: "createTime,desc",
      };

      return vbNotificationService.findAll(pageable).then((response) => {
        let items = response.data;
        items && this.$store.commit("loadMore", items);
        return items;
      });
    },

    countUnSeen() {
      return this.$store.getters.notificationsUnreadCount;
    },

    logout() {
      this.$router.push({ name: "logout" });
    },

    goToDashBoard() {
      this.$router.push({
        name: "dashboard",
      });
    },
  },
  data() {
    return {
      perfectScrollbarSetting: { maxScrollbarLength: 350 },
      pageable: { page: 0, size: 10, sort: "createTime,desc" },
      page: 1,
      size: 10,
      showNotify: false,
    };
  },
};
</script>

<style scoped>
.scroll-area {
  max-height: 500px;
  height: auto;
  width: 100%;
  position: relative;
  margin: auto;
}

.userSegment {
  color: var(--color-dark-cerulean);
  display: flex;
  align-items: center;
  line-height: initial;
  z-index: 2;
  margin-right: 24px;
  width: 270px;
  flex: 0 0 auto;
  justify-content: flex-end;
}

.userSegment .notifyToggler {
  margin-right: 24px;
  cursor: pointer;
}

.userSegment .notifyToggler i {
}

.userSegment .notifyToggler .el-badge {
}

.userSegment .profile {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.profile .thumbnail {
  width: 32px;
  height: 32px;
  /*background-color: rgba(0, 0, 0, 0.5);*/
  border-radius: 50%;
  flex: 0 0 auto;
  margin-right: 6px;
  /*border: 1px solid rgba(255, 255, 255, 0.4);*/
  background-image: url("../../assets/icon-user.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.userSegment .profile .txt {
}

.userSegment .profile .txt .name {
  display: block;
  font-weight: 600;
}

.userSegment .profile .txt .role {
  font-size: 12px;
  color: var(--color-smoke);
}

.btnIcon {
  text-align: center;
  margin-right: 20px;
}

.option.clickable:hover i {
  transform: scale(1.1);
  transition: var(--transition-regular);
}

.menu-user .profile {
  margin: 0;
  text-align: center;
}

.menu-user .profile .thumbnail {
  margin: 0 auto;
}

.menu-user .profile .name {
  margin: 8px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

.menu-user .profile .metaInfo {
  margin-bottom: 12px;
}

.menu-user .profile .metaInfo .item {
  display: flex;
  align-items: center;
}

.menu-user .profile .metaInfo .item i {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-light-2);
}

.menu-user .profile .metaInfo .item span {
  border-bottom: 1px solid var(--color-light);
  width: 100%;
  text-align: left;
  padding: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/header/user-header.vue